/* External */
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import classNames from 'classnames';

/* Assets */
import genericCard2x3 from '@/assets/theme/images/2x3-GenericCard.png';
import logo from '@/assets/theme/svg/logo.svg';

/* Components */
import Button from '../components/button/Button';

/* Styles */
import './NoEntitlement.scss';

/* Other */
import { api, history } from '../state/configureStore';
import {
  alcatrazFeatureFlag, decryptAllData,
  getSelfCareLinkAction, getSelfCareURL,
  GRADIENTS, PATHS, useImage,
} from '../utils';
import { getImage } from '../theme/images';
import { useIsResponsive } from '../hooks/useIsResponsive';

function NoEntitlement(props) {
  const {
    user,
    match: {
      params: { assetId },
    },
    intl: { formatMessage },
  } = props;
  const {
    data = {},
    isLoading,
  } = api.useGetAssetDetailQuery({ assetId });
  const isMobile = useIsResponsive('(max-width: 1024px)');
  const selfCareUrl = getSelfCareURL(user);
  const selfCareLinkAction = getSelfCareLinkAction(props);
  const genericCard2x3Flag = getImage('2x3GenericCard') || genericCard2x3;

  function selfCarePage() {
    if (alcatrazFeatureFlag) {
      decryptAllData();
    }
    selfCareLinkAction();

    window.location.href = selfCareUrl;
  }

  const images = data.images ?? [];

  const { imageRef, imageStyle } = useImage(
    images,
    genericCard2x3Flag,
    GRADIENTS.PDP_MOBILE,
    'RECTANGLE_VERTICAL',
    isLoading,
  );

  const content = (
    <div
      className={classNames('dtv-no-entitlement-content-frame', {
        loading: isLoading,
      })}
      ref={imageRef}
      style={imageStyle}
    >
      <div className="dtv-no-entitlement-content-frame-body">
        <div className="dtv-no-entitlement-content-frame-top">
          <img className="dtv-no-entitlement-content-frame-logo" src={getImage('logo') || logo} alt="Logo" />
          <div className="dtv-no-entitlement-content-frame-message">
            <h2 className="dtv-no-entitlement-content-frame-title">
              {formatMessage({
                id: 'pdp.noEntitlement.title',
                defaultMessage: 'Para ver este contenido debes gestionar tu suscripción',
              })}
            </h2>
            <p className="dtv-no-entitlement-content-frame-subtitle">
              {formatMessage({
                id: 'pdp.noEntitlement.subtitle',
                defaultMessage: 'Puedes cambiar de plan o agregar un extra.',
              })}
            </p>
          </div>
        </div>
        <div className="dtv-no-entitlement-content-frame-bottom">
          <Button onClick={() => selfCarePage()}>
            {formatMessage({
              id: 'pdp.noEntitlement.changeSubscription',
              defaultMessage: 'Gestionar suscripción',
            })}
          </Button>
          <Button
            variant="secondary"
            onClick={() => history.goBack()}
          >
            {formatMessage({
              id: 'common.not.now',
              defaultMessage: 'Ahora no',
            })}
          </Button>
        </div>
      </div>
    </div>
  );

  useEffect(() => {
    document.body.classList.add('no-scroll');
    return () => document.body.classList.remove('no-scroll');
  }, []);

  useEffect(() => {
    if (!isMobile) {
      history.replace(PATHS.HOME);
    }
  }, [isMobile]);

  return (
    <div className="dtv-no-entitlement">
      <div className="dtv-no-entitlement-icons">
        <div className="dtv-no-entitlement-icons-content">
          <span onClick={() => history.goBack()} className="dtv-no-entitlement-icons-icon dtv-icon-white-close" />
        </div>
      </div>
      <div className="dtv-no-entitlement-content">{content}</div>
    </div>
  );
}

function mapStateToProps({ user }) {
  return {
    user,
  };
}

NoEntitlement.propTypes = {
  match: PropTypes.shape({}).isRequired,
};

export default injectIntl(connect(mapStateToProps)(NoEntitlement));
